import React from "react"
import {  NAVIGATION_LINKS } from "../../constants/common"
import { Navigate } from "react-router-dom"

const TryNowOld = () => {
    return <Navigate to={NAVIGATION_LINKS.TRYNOW} replace/>
}

export default TryNowOld
